import React from 'react';
import Chart from 'react-apexcharts';
import { arrayAny } from '../../utils/arrayUtils';
import LoadingAnimation from "../loading/loading";

const SummaryCard = ({
	headerTitle,
	summaryValue,
	summaryValueMovement,
	summaryValueMovementSuffix,
	averageValue1,
	averageValue1Label,
	averageValue2,
	averageValue2Label,
	options,
	series,
	loading,
	error
}) => {

	const renderMovementIndicator = (value, suffix) => {
		if (!value) return <div></div>;

		const parsedValue = parseFloat(value).toFixed(2).toString();
		const formattedSuffix = suffix ? suffix.toString() : "";

		if (parsedValue > 0) {
			return (
				<div className="mb-3 text-gray-500">
					<i className="fa fa-caret-up"></i> {parsedValue + formattedSuffix} compared to last month
				</div>
			);
		} else if (parsedValue < 0) {
			return (
				<div className="mb-3 text-gray-500">
					<i className="fa fa-caret-down"></i> {Math.abs(parsedValue) + formattedSuffix} compared to last month
				</div>
			);
		} else {
			return <div></div>;
		}
	};

	const renderChart = (chartOptions, chartSeries) => {
		if (chartOptions && chartSeries && arrayAny(chartSeries.flatMap(s => s.data))) {
			return (
				<div className="ms-auto mt-n1 mb-n1">
					<Chart
						type={chartOptions.chart.type}
						height={chartOptions.chart.height}
						width={chartOptions.chart.width}
						options={chartOptions}
						series={chartSeries}
					/>
				</div>
			);
		} else {
			return <div></div>;
		}
	};

	// Determine if we should show the additional content
	const showAdditionalContent = !error && !loading;

	return (
		<div style={{ minHeight: '195px' }} className="card border-0 mb-3 overflow-hidden bg-gray-800 text-white">
			<div className="card-body">
				<div className="row">
					<div className="col-xl-12 col-lg-12">
						<div className="mb-3 text-gray-500">
							<b>{headerTitle}</b>
						</div>
						<div className="d-flex mb-1">
							{error ? (
								<div className="text-red-500">
									{error}
								</div>
							) : !loading ? (
								<>
									<h2 className="mb-0">{summaryValue}</h2>
									{arrayAny(series) && renderChart(options, series)}
								</>
							) : (
								<LoadingAnimation />
							)}
						</div>

						{/* Only render these sections if there's no error and loading has completed */}
						{showAdditionalContent && (
							<>
								{renderMovementIndicator(summaryValueMovement, summaryValueMovementSuffix)}

								{(averageValue1 || averageValue2) && (
									<hr className="bg-white-transparent-2" />
								)}

								{(averageValue1 || averageValue2) && (
									<div className="row text-truncate">
										{averageValue1 && (
											<div className="col-6">
												<div className="fs-12px text-gray-500">{averageValue1Label}</div>
												<div className="fs-18px mb-5px fw-bold">{averageValue1}</div>
											</div>
										)}

										{averageValue2 && (
											<div className="d-flex col-6">
												<div className='ms-auto'>
													<div className="fs-12px text-gray-500">{averageValue2Label}</div>
													<div className="text-end fs-18px mb-5px fw-bold">{averageValue2}</div>
												</div>
											</div>
										)}
									</div>
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default SummaryCard;